export const getPercentageChange = (current = 0, previous = 0) => {
	if (previous === 0) return 0;
	return (((current - previous) / previous) * 100).toFixed(0);
};

export const formatDate = (date?: string) => {
	if (!date) return "N/A";

	const dateObject = new Date(date);

	const year = dateObject.getFullYear();
	const month = String(dateObject.getMonth() + 1).padStart(2, "0");
	const day = String(dateObject.getDate()).padStart(2, "0");
	const hours = String(dateObject.getHours()).padStart(2, "0");
	const minutes = String(dateObject.getMinutes()).padStart(2, "0");
	const seconds = String(dateObject.getSeconds()).padStart(2, "0");

	const formatted = `${year}\u2011${month}\u2011${day}, ${hours}:${minutes}:${seconds}`;
	return formatted;
};

export const formatDateWithTimezone = (date: string | Date, timezone?: string): string => {
	if (!date) return "N/A";

	try {
		const dateObject = typeof date === "string" ? new Date(date) : date;

		if (timezone) {
			const formatter = new Intl.DateTimeFormat("en-US", {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit",
				hour12: false,
				timeZone: timezone,
			});

			const parts = formatter.formatToParts(dateObject);
			const partsMap = new Map(parts.map((p) => [p.type, p.value]));

			const year = partsMap.get("year");
			const month = partsMap.get("month");
			const day = partsMap.get("day");
			const hour = partsMap.get("hour");
			const minute = partsMap.get("minute");
			const second = partsMap.get("second");

			return `${year}\u2011${month}\u2011${day}, ${hour}:${minute}:${second}`;
		}

		return formatDate(dateObject.toISOString());
	} catch (error) {
		console.error("Error formatting date with timezone:", error);
		return formatDate(typeof date === "string" ? date : date.toISOString());
	}
};

export const formatDuration = (duration: number) => {
  if (!duration) {
    return '-';
  }

  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;

  if (minutes > 0) {
    return `${minutes} min${seconds > 0 ? ` ${seconds} sec` : ''}`;
  }

  return `${seconds} sec`;
};

export function getFilenameFromContentDisposition(response: Response): string {
	const disposition = response.headers.get("Content-Disposition");

	if (disposition) {
		const match =
			disposition.match(/filename\*=UTF-8''([^;]+)/i) ||
			disposition.match(/filename="?([^"]+)"?/i);
		if (match) {
			return decodeURIComponent(match[1]);
		}
	}

	return "";
}

export function downloadBlob(blob: Blob, filename: string): void {
	const url = globalThis.URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.download = filename;
	document.body.append(link);
	link.click();
	link.remove();
	globalThis.URL.revokeObjectURL(url);
}

export async function downloadFileFromResponse(response: Response, defaultFilename = ""): Promise<void> {
	const filename = getFilenameFromContentDisposition(response) || defaultFilename;
	const blob = await response.blob();
	downloadBlob(blob, filename);
}
